import React from 'react';
import { v4 } from 'uuid';
import styled from 'styled-components';

import CompoundExecutionStepDetails from '../../compound/execution/StepDetails';
import {
  defaultCompoundStepCount,
  defaultCompoundStepCountOperator,
} from '../../../constants/compound';
import { isStepEnabled } from '../../../utils/compound';
import ConversionChart from '../../../containers/dashboards/preview/FunnelChart';

const StyleContainer = styled.div`
  width: 100%;
  font-size: 0.8em;
  text-align: left;

  .step-details-wrapper {
    height: 100%;
    width: 100%;
    overflow-y: auto;
  }

  .conversion-chart-container {
    height: 100%;
  }
`;

const FunnelExecutionDetails = ({
  chart,
  stepCounters = [],
  steps,
  perStepClosingRangeEnabled,
  unit,
  conversionIntervalIsNone,
  setChart,
}) => {
  const totalCount = stepCounters.length ? stepCounters[0].count : 0;
  let index = 0;

  let optionalStepIndex = steps.findIndex((c) => c.optional);

  optionalStepIndex =
    optionalStepIndex > -1 && steps[optionalStepIndex].enabled ? optionalStepIndex : steps.length;

  // флаг для отображения Closing range
  let isStepClosingRange = false;

  const isOnlyOneEnabledStep = steps.filter((step) => step.enabled).length === 1;
  const isShowStepDetails = conversionIntervalIsNone || steps.length === 1 || isOnlyOneEnabledStep;

  return (
    <StyleContainer>
      {isShowStepDetails && (
        <div className="step-details-wrapper">
          {steps.map((step, i) => {
            const stepCounter = stepCounters[index] || {};
            // Closing range не должен отображаться для первых шагов и задизейбленных шагов.
            // если первый шаг был задизейблен то второй шаг будет считаться первым (Closing range не отображается)
            if (!isStepClosingRange && i !== 0) {
              isStepClosingRange = steps[i - 1].enabled !== false;
            }

            // больше чем 1 подряд optional быть не может, поэтому если предыдущий шаг был optional, то срабатывает index-2.
            const prevStep = (idx) =>
              (stepCounters[idx - 1] || {}).count !== undefined
                ? (stepCounters[idx - 1] || {}).count
                : (stepCounters[idx - 2] || {}).count;

            const stepDetails = (
              <CompoundExecutionStepDetails
                totalCount={totalCount}
                stepNum={index + 1}
                prevStepCount={prevStep(index)} // first iteration: negative indexes are treated as properties, so it's ok
                prevStepOptionalCount={
                  i > optionalStepIndex ? (stepCounters[index - 1] || {}).optionalCount : undefined
                }
                stepCount={stepCounter.count}
                optionalStepCount={i >= optionalStepIndex ? stepCounter.optionalCount : undefined}
                stepEvent={step.event}
                stepLegendName={step.legendName}
                stepFilter={step.filter}
                stepDescription={step.descriptionVisible && step.description}
                stepClosingRange={
                  perStepClosingRangeEnabled && isStepClosingRange ? step.closingRange : undefined
                }
                stepRequiredCount={step.count || defaultCompoundStepCount}
                stepRequiredCountOperator={step.countOperator || defaultCompoundStepCountOperator}
                disabled={!isStepEnabled(step.enabled)}
                key={v4()}
                optional={step.optional}
                fromDashboard
              />
            );

            if (isStepEnabled(step.enabled)) {
              index += 1;
            }

            return stepDetails;
          })}
        </div>
      )}

      {chart && !conversionIntervalIsNone ? (
        <div className="conversion-chart-container">
          <ConversionChart unit={unit} setChart={setChart} />
        </div>
      ) : undefined}
    </StyleContainer>
  );
};

export default FunnelExecutionDetails;
